<template>
  <b-modal id="welcome-message-modal"
            class="basic-modal hide-cancel-btn"
            v-bind:close-on-backdrop="false"
            v-bind:ok-title="$t('common.modal.welcome_msg.start')"
            v-on:ok="setTutorialAsChecked('welcome')">
    <div slot="modal-header">
      <h5 class="typography--title" v-html="$t('common.modal.welcome_msg.title')">
      </h5>
    </div>

    <div class="typography--body-3 typography--color-secondary mb-4 mt-6">
      <img src="/static/images/icon-check.svg" class="mr-12">
      {{ $t('common.modal.welcome_msg.body_1') }}
    </div>
    <div class="typography--body-3 typography--color-secondary mb-4">
      <img src="/static/images/icon-check.svg" class="mr-12">
      {{ $t('common.modal.welcome_msg.body_2') }}
    </div>
    <div class="typography--body-3 typography--color-secondary">
      <img src="/static/images/icon-check.svg" class="mr-12">
      {{ $t('common.modal.welcome_msg.body_3') }}
    </div>
  </b-modal>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'welcome-message-modal',

    methods: {
      ...mapActions([
        'setTutorialAsChecked',
      ]),
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/WelcomeMessageModal.vue